import { useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { IAccountInfo } from "../types/services.interfaces/user_piis";

export const useGetAccountInfo = () => {
    const enabled = AuthHelper.presetPrivateRequest(api);

    const queryFn = async (): Promise<IAccountInfo> => {
        const res = await api.get(`/user_piis/account-info`);
        return res.data;
    };

    return useQuery({
        queryKey: ['account-info'],
        queryFn,
        retry: false,
        enabled,
    });
};